import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function FinalClose() {
  return <section className="relative w-full overflow-hidden bg-ink-950 py-12 sm:py-16" data-id="element-62">
      <div className="absolute inset-0 bg-lab-grid opacity-30" aria-hidden="true" data-id="element-63" />
      <div className="absolute inset-0 bg-radial-cyan opacity-60" aria-hidden="true" data-id="element-64" />
      <div className="relative mx-auto max-w-5xl px-5" data-id="element-65">
        <SectionHeading eyebrow="El Cierre" data-id="element-66">
          Tienes dos caminos ahora mismo
        </SectionHeading>

        <div className="mt-8 grid gap-6 md:grid-cols-2" data-id="element-67">
          <Reveal data-id="element-68">
            <div className="flex h-full flex-col rounded-3xl border border-urgency/25 bg-urgency/5 p-7" data-id="element-69">
              <span className="inline-flex w-fit items-center gap-2 rounded-full bg-urgency/15 px-3 py-1 text-xs font-bold uppercase tracking-widest text-urgency" data-id="element-70">
                <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-71" /> Camino A
              </span>
              <p className="mt-4 text-sm leading-relaxed text-silver/75 sm:text-base" data-id="element-72">
                Seguir intentando adivinar cómo funciona la IA, perdiendo horas
                frente a una pantalla en blanco y viendo cómo otros se llevan a
                tus clientes por ser más rápidos.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-73">
            <div className="flex h-full flex-col rounded-3xl border border-accent/40 bg-accent/5 p-7 shadow-glow-cyan" data-id="element-74">
              <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent/20 px-3 py-1 text-xs font-bold uppercase tracking-widest text-accent-light" data-id="element-75">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-76" /> Camino
                B
              </span>
              <p className="mt-4 text-sm leading-relaxed text-silver/85 sm:text-base" data-id="element-77">
                Adquirir PROMPT LABS hoy, instalar un cerebro de ejecución en tu
                negocio y materializar cualquier idea en lo que tarda en hacerse
                un café.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2} data-id="element-78">
          <p className="mt-10 text-center font-display text-3xl uppercase tracking-tight text-chrome sm:text-4xl" data-id="element-79">
            Elige la velocidad.{' '}
            <span className="text-cyan-gradient" data-id="element-80">Elige el resultado.</span>
          </p>
        </Reveal>

        <Reveal delay={0.3} data-id="element-81">
          <div className="mt-10" data-id="element-82">
            <CtaButton data-id="element-83" />
          </div>
        </Reveal>
      </div>
    </section>;
}